import { useEffect, useRef } from 'react'
import styled from 'styled-components'

const EmptyDiv = styled.div`
    display: none;
`

const TimeStamp = ({ name, setValue, testId }) => {
    const hasSetTimestamp = useRef(false)

    useEffect(() => {
        // Only set timestamp once when component mounts
        if (!hasSetTimestamp.current && setValue && name) {
            try {
                // Set the current timestamp when the component mounts
                const currentTimestamp = new Date().toISOString()
                
                // Create the event-like object that matches the pattern used in FormElem
                const timestampEvent = {
                    target: {
                        name: name,
                        value: currentTimestamp
                    }
                }
                
                // Call setValue with the timestamp
                setValue(timestampEvent)
                hasSetTimestamp.current = true
            } catch (error) {
                console.error('TimeStamp component error:', error)
            }
        }
    }, []) // Empty dependency array - only run once on mount

    // This component is hidden - it doesn't render anything visible
    return <EmptyDiv />
}

export default TimeStamp
